module.exports = __webpack_public_path__ + "static/media/send.4169cbc9.svg";